import { createAsyncThunk } from "@reduxjs/toolkit";
import { headers, headerConfiguration } from "../../store/auth/headerConfig";
import api from "../../store/api/api";


export const createProject = createAsyncThunk(
  'projects/createProject',
  async (projectData, { dispatch, getState, rejectWithValue }) => {
    const headerConfig = headerConfiguration(getState, headers);
    const url = `${process.env.REACT_APP_SERVER_URL}/api/projects/create/`;

    const payload = {
      name: projectData.name,
      description: projectData.description,
      goals: projectData.goals,
      funding_stage: projectData.funding_stage,
      tags: projectData.tags
    };

    try {
      // console.log(" Submitting payload:", payload);

      const response = await api(url, "POST", headerConfig, payload, dispatch);

      if (!response || !response.project_id) {
        return rejectWithValue("Invalid response from server");
      }

      return response;
    } catch (error) {
      return rejectWithValue(error?.message || "Failed to create project");
    }
  }
);


export const getAllProjects = createAsyncThunk(
  'projects/getAllProjects',
  async (_, { dispatch, getState, rejectWithValue }) => {
    const headerConfig = headerConfiguration(getState, headers);
    try {
      const url = `${process.env.REACT_APP_SERVER_URL}/api/projects/`;
      const response = await api(url, "GET", headerConfig, null, dispatch);
      return response;
    } catch (error) {
      return rejectWithValue(error?.message || "Failed to fetch projects");
    }
  }
);


export const getProjectById = createAsyncThunk(
  'projects/getProjectById',
  async ({project_id} , { dispatch, getState, rejectWithValue }) => {
    const headerConfig = headerConfiguration(getState, headers);
    try {
      const url = `${process.env.REACT_APP_SERVERS_URL}/api/projects/get/${project_id}/`;
      const response = await api(url, "GET", headerConfig, null, dispatch);
      // console.log("headerConfig:", headerConfig)
      console.log("URL:", `${process.env.REACT_APP_SERVERS_URL}/api/projects/get/${project_id}/`);

      return response;
    } catch (error) {
      return rejectWithValue(error?.message || "Failed to fetch project");
    }
  }
);